import { render, staticRenderFns } from "./PromotionLink.vue?vue&type=template&id=adde8672&"
import script from "./PromotionLink.vue?vue&type=script&lang=js&"
export * from "./PromotionLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports